import { Duplexer } from '@wix/duplexer-js';
import { DuplexerEvent, DuplexerSubscriber } from '@wix/wix-help-widget-common/duplexer';
import { Store } from 'redux';

import { TRootState } from '../common/reducers';
import { chatActions } from '../common/reducers/chat';
import { logger } from '../util/logger';

export class MessageReadSubscriber extends DuplexerSubscriber {
  constructor(
    protected readonly duplexer: Duplexer,
    protected readonly appDefId: string,
    private readonly store: Store<TRootState>,
  ) {
    super(duplexer, appDefId, logger);

    this.subscribe(DuplexerEvent.MESSAGE_READ, this.onMessageRead);
  }

  unsubscribe() {
    super.unsubscribe();
  }

  private onMessageRead = (): void => {
    this.store.dispatch(chatActions.resetUnreadCount());
  };
}
